import React, { useReducer } from 'react'
import GitlabContext from './asinContext'
import GitlabReducer from './asinReducer'
import { apiCall } from '../../../common/api'
import { response } from '../../common'

import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_PRODUCT,
    GET_UPI_PRODUCT,
    GET_CATALOG_PRODUCT,
    GET_AI_PRODUCT,
    GET_VIN_PRODUCT,
    GET_IMAGE_PRODUCT,
} from './asinTypes'
import asinReducer from './asinReducer'

const AsinState = (props) => {
    const initialState = {
        responseStatus: null,
        all_products: {
            record: {},
            from: '',
            message: '',
        },
        upc_products: {
            record: {},
            from: '',
        },
        catalog_products: {
            record: {},
            from: '',
        },
        ai_products: {
            record: {},
            from: '',
        },
        vin_products: {
            record: {},
            from: '',
        },
        image_products: {
            record: {},
            from: '',
        },
    }

    const [state, dispatch] = useReducer(asinReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const retrieveProduct = async (
        formData,
        fromVariable = 'retrieveProduct'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'retrieveProduct',
                    formData,
                    '',
                    'third_party/asinscope'
                ),
            ])

            if (res.data.status === 'success') {
                console.log(res.data.data.responseData.records, 'reeee')
                dispatch({
                    type: GET_PRODUCT,
                    payload: {
                        record: res.data.data.responseData.records
                            ? res.data.data.responseData.records
                            : {},
                        from: fromVariable,
                        message: res.data.data.message,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const retrieveUpcProduct = async (
        formData,
        fromVariable = 'retrieveUpcProduct'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'retrieveProduct',
                    formData,
                    '',
                    'third_party/upc'
                ),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_UPI_PRODUCT,
                    payload: {
                        record: res.data.data.responseData.records
                            ? res.data.data.responseData.records
                            : {},
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getCatalog = async (formData, fromVariable = 'getCatalog') => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getCatalog',
                    formData,
                    '',
                    'third_party/cyber'
                ),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_CATALOG_PRODUCT,
                    payload: {
                        record: res.data.data.responseData.records
                            ? res.data.data.responseData.records
                            : {},
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getAiSearch = async (formData, fromVariable = 'getAiSearch') => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAiSearch',
                    formData,
                    '',
                    'third_party/cyber'
                ),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_AI_PRODUCT,
                    payload: {
                        record: res.data.data.responseData
                            ? res.data.data.responseData
                            : {},
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getVinSearch = async (formData, fromVariable = 'getVinSearch') => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'titleSearch',
                    formData,
                    '',
                    'third_party/aisearch'
                ),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_VIN_PRODUCT,
                    payload: {
                        record: res.data.data.responseData
                            ? res.data.data.responseData
                            : {},
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            console.log('errorrrr', err)
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getImageSearch = async (
        formData,
        fromVariable = 'getImageSearch'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'ImageSearch',
                    formData,
                    '',
                    'third_party/aisearch'
                ),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_IMAGE_PRODUCT,
                    payload: {
                        record: res.data.data.responseData
                            ? res.data.data.responseData
                            : {},
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            console.log('errorrrr', err)
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <GitlabContext.Provider
            value={{
                responseStatus: state.responseStatus,
                all_products: state.all_products,
                upc_products: state.upc_products,
                catalog_products: state.catalog_products,
                ai_products: state.ai_products,
                vin_products: state.vin_products,
                image_products: state.image_products,
                getAiSearch,
                getCatalog,
                retrieveProduct,
                retrieveUpcProduct,
                clearResponse,
                getVinSearch,
                getImageSearch,
            }}
        >
            {props.children}
        </GitlabContext.Provider>
    )
}

export default AsinState
